import React, { useCallback, useMemo, useState } from 'react';
import { MdRefresh } from 'react-icons/all';
import Button from 'src/components/Button';
import { Container, RefreshIconStyle } from './styles';

const dateFormat = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };

interface IProps {
  onClick: () => Promise<void>;
  loading: boolean;
}

const Refresh = ({ onClick, loading }: IProps) => {
  const [lastUpdate, setLastUpdate] = useState<Date>(new Date());

  const message = useMemo((): string => {
    return loading ? 'Carregando...' :
      `Última atualização ${lastUpdate.toLocaleDateString('pt-BR', dateFormat)}`;
  }, [loading, lastUpdate]);

  const handleOnClick = useCallback(() => {
    onClick().then(() => setLastUpdate(new Date()));
  }, [onClick]);

  return (
    <Container>
      <span>{message}</span>
      <Button onClick={handleOnClick} disabled={loading}>
        <MdRefresh style={RefreshIconStyle} />
        Atualizar
      </Button>
    </Container>
  );
};

export default Refresh;